import Vue from 'vue';
import { fromUnixTime, parse, format, getUnixTime } from 'date-fns';
// import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';
// const timeZone = 'Europe/Berlin';

import { get } from '@/helpers';

// TODO
// move to a separate filters file in the shop extension
export const findPrice = (article, customer, defaultCustomerGroup, object = false) => {
  let price = 0;

  let type = 'main';
  if (customer && defaultCustomerGroup.id !== get(customer, 'customerGroup.id')) type = 'group';

  let p;
  if (type === 'main') p = article.prices.find(el => el.type === type);
  else p = article.prices.find(el => get(el, 'customerGroup.id') === get(customer, 'customerGroup.id'));

  if (p && p.value) {
    if (object) price = p;
    else price = p.value;
  }
  return price;
};

export const timestamp2date = value => {
  return fromUnixTime(value);
};
Vue.filter('timestamp2date', timestamp2date);

export const date2timestamp = (value, pattern = 'dd.MM.yyyy') => {
  return getUnixTime(parse(value, pattern, new Date()));
};
Vue.filter('date2timestamp', date2timestamp);

export const formatDate = (value, pattern = 'dd.MM.yyyy') => {
  if (value === null) return '';
  return format(value, pattern);
};
Vue.filter('formatDate', formatDate);

export const formatTimestamp = (value, pattern = 'dd.MM.yyyy') => {
  if (value === null) return '';
  return format(timestamp2date(value), pattern);
};
Vue.filter('formatTimestamp', formatTimestamp);

export const moneyFormat = (value, currency = 'EUR') => {
  const language = window.navigator.userLanguage || window.navigator.language;
  return Intl.NumberFormat(language, { style: 'currency', currency }).format(value);
};
Vue.filter('moneyFormat', moneyFormat);
